module.exports = __webpack_public_path__ + "images/83274c187b6484b52037e36c480b03bb-brain-background.png";